import { useIntl } from 'react-intl'

import { Paper } from '@gto/ui/paper'
import { Skeleton } from '@gto/ui/skeleton'

import { AssetGrid } from './asset-grid'

/** Loading state shaped like the real cards — no spinner, no layout jump. */
export const AssetGridSkeleton = () => {
  const { formatMessage } = useIntl()

  return (
    <div
      aria-label={formatMessage({ id: 'assets.loading' })}
      role="status"
    >
      <AssetGrid>
        {Array.from({ length: 8 }, (_, i) => (
          <Paper
            key={i}
            className="flex flex-col overflow-hidden rounded-md"
            elevation="2"
          >
            <Skeleton
              className="aspect-video h-auto w-full"
              variant="rectangular"
            />
            <div className="flex flex-col gap-0.5 px-3 py-2">
              <Skeleton
                variant="text"
                width="70%"
              />
              <Skeleton
                variant="text"
                width="40%"
              />
            </div>
          </Paper>
        ))}
      </AssetGrid>
    </div>
  )
}
